import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import '../styles/index.scss';
import AOS from "aos";
import "aos/dist/aos.css";
import "aos/dist/aos.js";

class Main {
	constructor() {
		this.onDOMLoaded();
		this.onDocumentLoad();
		this.onResize();
		window.jQuery = $;
		window.$ = $;

	}

	onDocumentLoad() {
		window.addEventListener("load", (event) => {

		});
	}

	onDOMLoaded() {
		document.addEventListener("DOMContentLoaded", (event) => {
			// slider
			$('.property-slider').owlCarousel({
				items: 1,
				loop: true,
				margin: 24,
				dots: true,
				nav: true,
				autoplay: true,
			});

			// client slider
			$('.testimonals-slider').owlCarousel({
				items: 3,
				loop: true,
				margin: 12,
				dots: false,
				nav: true,
				autoplay: true,
				responsiveClass:true,
				responsive : {			    
			    0 : {
			       items:1,
			    },			   
			    600 : {
			        items:2,
			    },			    
			    991 : {
			        items:2,
			    }
			    ,			    
			    992 : {
			        items:3,
			    }
			}
			});

			// mobile Menu
			$(".menu-toggle").click(function () {
				$("html").toggleClass("menuactive");
			});
			$(".site-header .site-navigation ul > li a").click(function () {
				$("html").removeClass("menuactive");
			});

			$("#menu-mainmenu li a").click(function (e) {
				e.preventDefault();
				$('html, body').animate({
					scrollTop: $($.attr(this, 'href')).offset().top - 80
				}, 500);
			});

			AOS.init({ duration: 1200 });

		});
	}

	onResize() { }



}

new Main();

$(function () {

});


// WEBPACK FOOTER //
// ./src/scripts/index.js